/// <amd-module name="Test/TestCaseResults/Utils" />
import * as Resources from "Test/TestCaseResults/Resources";
import * as Contracts from "TestPlanCommon/Contracts/TestPlan";
import { IVssPageContext } from "VSS/Platform/Context";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";
import { IVssContributionService } from "VSS/Platform/Contribution";

export function getDataProviderContentForTestResults(pageContext: IVssPageContext): Contracts.TestCaseResultsData {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const data = contributionService.getData<Contracts.TestCaseResultsData>(
        "ms.vss-test-web.testcase-results-data-provider"
    ) as Contracts.TestCaseResultsData;

    return data;
}

export function getOutcomeString(pointOutcome: Contracts.UserFriendlyTestOutcome) {
    if (pointOutcome === Contracts.UserFriendlyTestOutcome.Passed) {
        return Resources.Passed;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Failed) {
        return Resources.Failed;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Blocked) {
        return Resources.Blocked;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.NotApplicable) {
        return Resources.NotApplicable;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Paused) {
        return Resources.Paused;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.InProgress) {
        return Resources.InProgress;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Timeout) {
        return Resources.Timeout;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Warning) {
        return Resources.Warning;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Error) {
       return Resources.Error;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.NotExecuted) {
        return Resources.NotExecuted;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Inconclusive) {
        return Resources.Inconclusive;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Aborted) {
        return Resources.Aborted;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.None) {
        return Resources.None;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.Unspecified) {
        return Resources.Unspecified;
    } else if (pointOutcome === Contracts.UserFriendlyTestOutcome.NotImpacted) {
        return Resources.NotImpacted;
    } else {
        return Resources.Active;
    }
}

export function getDisplayName(identity: VS_Services.IdentityRef) {
    if (identity && identity.displayName) {
        return identity.displayName;
    }
    return Resources.Unassigned;
}
